import { useChannel } from './useChannel';

export function useChannelId(channelSlug: string): number | undefined {
  const channel = useChannel({ channelSlug });
  return channel?.id;
}
